import React, { useState } from 'react';
import '../css/DeviceStateView.css';

const fmtKST = new Intl.DateTimeFormat('ko-KR', {
  dateStyle: 'medium',
  timeStyle: 'medium',
  timeZone: 'Asia/Seoul',
});

function parseDeviceTs(ts) {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  if (typeof ts === 'number') return new Date(ts < 1e12 ? ts * 1000 : ts);
  if (typeof ts === 'string') {
    const s = ts.trim();
    if (/[Zz]$/.test(s) || /[+-]\d\d:?\d\d$/.test(s) || /UTC/i.test(s)) {
      const d = new Date(s);
      return isNaN(d) ? null : d;
    }
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
      const d = new Date(s.replace(' ', 'T') + '+09:00');
      return isNaN(d) ? null : d;
    }
    const d = new Date(s);
    return isNaN(d) ? null : d;
  }
  return null;
}

function timeAgo(d) {
  const sec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (sec < 30) return '방금 전';
  if (sec < 60) return `${sec}초 전`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}시간 전`;
  const day = Math.floor(hr / 24);
  return `${day}일 전`;
}

function freshnessClass(d) {
  const min = Math.floor((Date.now() - d.getTime()) / 60000);
  if (min <= 2) return 'ts-chip fresh';
  if (min <= 10) return 'ts-chip warm';
  return 'ts-chip stale';
}

// ---- 배터리 % 변환 ----
function batteryPercentFromAdc(adc) {
  const min = 1100, max = 1500;
  const v = Number(adc);
  if (!Number.isFinite(v)) return 0;
  const pct = Math.round(((v - min) / (max - min)) * 100);
  return Math.max(0, Math.min(100, pct));
}

// ---- 필드 정의 & 포맷터 ----
const FIELDS = {
  id: { label: 'ID' },
  timestamp: {
    label: '수집 시각',
    render: (val) => {
      const d = parseDeviceTs(val);
      if (!d) return '정보 없음';
      return (
        <span className={freshnessClass(d)} title={String(val)}>
          {fmtKST.format(d)} <small>({timeAgo(d)})</small>
        </span>
      );
    },
  },
  temperature: {
    label: '온도',
    render: (v) => (v == null ? '—' : `${v} ℃`),
  },
  bat_adc_value: {
    label: '배터리 잔량',
    render: (v) => `${batteryPercentFromAdc(v)}%`,
  },
  motorDir: { label: '지시 방향' },
  scanStatus: { label: '동작 모드' },
  scanAngle: { label: '동작 각도' },
  smoke: { label: '연기 감지', type: 'flag' },
  blackout: { label: '정전 감지', type: 'flag' },
  temp_flag: { label: '온도 감지', type: 'flag' },
  ffFacility: { label: '외부 신호 감지', type: 'flag' },
  motorFlag: { label: '경보 여부', type: 'flag' },
  smoke_avg_val: { label: '현재 연기 농도 값'},
  moving_standard_smoke: { label: '연기 농도 기준 값'},
};

function renderValue(key, val, def) {
  if (def?.render) return def.render(val);
  if (def?.type === 'flag') {
    const on = Number(val) === 1 || val === true;
    return <span className={`flag-chip ${on ? 'on' : 'off'}`}>{on ? 'ON' : 'OFF'}</span>;
  }
  return val ?? '—';
}

export default function DeviceStateView({ data }) {
  const [selectedKey, setSelectedKey] = useState(null);
  if (!data || typeof data !== 'object') return null;

  return (
    <div className="device-state-card">
      <h3 className="device-state-title">LES 상태</h3>
      <div className="device-grid">
        {Object.entries(FIELDS).map(([key, def]) => (
          <div
            key={key}
            className={`device-grid-item ${selectedKey === key ? 'selected' : ''}`}
            onClick={() => setSelectedKey(key)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && setSelectedKey(key)}
          >
            <div className="device-grid-label">{def.label}</div>
            <div className="device-grid-value">{renderValue(key, data[key], def)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}